import API from '../../api';
import { TeamContainer, UserContainer } from '../../providers';

const useGetMembers = () => {
  const { setMembers, setIsLoading } = TeamContainer.useContainer();

  const getMembers = async businessId => {
    setIsLoading(true);
    const members = await API.team.find({ businessId });
    setMembers(members, businessId);

    setIsLoading(false);
  };

  return getMembers;
};

const useAddMember = () => {
  const { addNewMember } = TeamContainer.useContainer();
  const { state: userState } = UserContainer.useContainer();
  const businessId = userState?.business?.id?.toString();

  const addMember = async ({ email, role, clientIds }) => {
    const member = await API.team.create({
      businessId,
      email,
      role,
      clientIds,
    });
    addNewMember(member);
  };

  return addMember;
};

const useDeleteMember = () => {
  const { removeMember } = TeamContainer.useContainer();
  const { state: userState, setBusinessOptions } = UserContainer.useContainer();
  const businessId = userState?.business?.id;

  const deleteMember = async (id, updateBusinessOption = false) => {
    await API.team.delete(id, { businessId });
    removeMember(id);
    if (updateBusinessOption) {
      const updatedBussiness = userState.businessOptions
        .map(business => {
          if (businessId === business.id) {
            return null;
          }

          return business;
        })
        .filter(business => business !== null);
      setBusinessOptions(updatedBussiness);
    }
  };

  return deleteMember;
};

const useUpdatePermissions = () => {
  const { updateMemberPermissions } = TeamContainer.useContainer();

  const updatePermissions = async (id, permissions) => {
    const newPermissions = await API.permission.update(id, permissions);
    updateMemberPermissions(newPermissions);
  };

  return updatePermissions;
};

const useSendInvite = () => {
  const { state: userState } = UserContainer.useContainer();
  const businessId = userState?.business?.id?.toString();

  const sendInvite = async (id, accessId, invitedUserEmail) => {
    await API.team.sendInvite({
      teamMemberId: id.toString(),
      businessId,
      accessId: accessId.toString(),
      invitedUserEmail,
    });
  };

  return sendInvite;
};

const useAcceptInvite = () => {
  const { state: userState, setBusinessOptions } = UserContainer.useContainer();
  const acceptInvite = async (id, businessId) => {
    const response = await API.access.update(
      id,
      {
        acceptedInviteDate: new Date(),
      },
      { businessId }
    );

    const updatedBussiness =
      userState?.businessOptions?.map(business => {
        if (business.id === response.businessId) {
          return { ...business, access: response };
        }

        return business;
      }) ?? [];
    if (updatedBussiness.length > 0) {
      setBusinessOptions(updatedBussiness);
    }
  };

  return acceptInvite;
};

const useRejectInvite = () => {
  const { state: userState, setBusinessOptions } = UserContainer.useContainer();
  const rejectInvite = async (id, businessId) => {
    const response = await API.access.delete(id, { businessId });
    const updatedBussiness = userState.businessOptions
      .map(business => {
        if (business.id === response.businessId) {
          return null;
        }

        return business;
      })
      .filter(business => business !== null);
    setBusinessOptions(updatedBussiness);
  };

  return rejectInvite;
};

export {
  useGetMembers,
  useAddMember,
  useDeleteMember,
  useUpdatePermissions,
  useSendInvite,
  useAcceptInvite,
  useRejectInvite,
};
